// extracted by mini-css-extract-plugin
export var borderRadius = "_5x-4";
export var large = "_5x-3";
export var logoContainer = "_5x-0";
export var nameLogo = "_5x-2";
export var small = "_5x-1";